module.exports = __webpack_public_path__ + "img/omimg2.28d58228.png";